export default "__VITE_ASSET__D9e7dwPX__"